import type { ButtonHTMLAttributes, Ref } from 'react'
import styles from './ui.module.css'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'default' | 'primary'
  /** React 19 treats ref as an ordinary prop; no forwardRef needed. */
  ref?: Ref<HTMLButtonElement>
}

export function Button({ variant = 'default', className, type = 'button', ...rest }: Props) {
  const classes = [styles.button, variant === 'primary' ? styles.primary : '', className ?? '']
    .filter(Boolean)
    .join(' ')
  return <button type={type} className={classes} {...rest} />
}
